module.exports = __webpack_public_path__ + "img/bg.c584cf94.jpg";